import { ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useEngineeringService from '../useEngineeringService';
import { EngineeringIncidentReport, SaveIncidentPayload } from '../types';
import { modalActionsSx } from '../shared/modalActionsSx';
import IncidentForm from './IncidentForm';
import { incidentValidation } from './incidentValidation';

interface CreateIncidentModalProps {
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
  onSaved: (incident: EngineeringIncidentReport) => void;
}

const CreateIncidentModal = ({ projectId, isOpen, onClose, onSaved }: CreateIncidentModalProps) => {
  const { createIncident } = useEngineeringService();

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Add incident">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitButtonText="Add incident"
        actionsSx={modalActionsSx}
        submitFormFunc={async values => {
          const { shortDescription, severity, linkToDetails, notes } = values;
          const payload: SaveIncidentPayload = {
            shortDescription,
            severity,
            linkToDetails,
            notes,
          };
          return { result: await createIncident(projectId, payload) };
        }}
        afterSubmit={{
          message: 'You are awesome! Incident has been successfully created.',
          execute: (response: { result: EngineeringIncidentReport }) => onSaved(response.result),
        }}
        getValidationSchemaFunc={() => Promise.resolve(incidentValidation)}
      >
        <IncidentForm />
      </ModalForm>
    </Modal>
  );
};

export default CreateIncidentModal;
